import { render, staticRenderFns } from "./HeaderWalletDrawer.vue?vue&type=template&id=3fb76192"
import script from "./HeaderWalletDrawer.vue?vue&type=script&lang=js"
export * from "./HeaderWalletDrawer.vue?vue&type=script&lang=js"
import style0 from "./HeaderWalletDrawer.vue?vue&type=style&index=0&id=3fb76192&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports